<template>
  <div id="wrapper" class="gray-bg login-bg">
    <div class="container">

      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">

          <div class="login">

            <div class="logo">
              <h1>Verifying Account</h1>
            </div>

            <div class="login-content text-center">
              <div v-if="verifying">
                <p class="m-b-lg lead">
                  Please wait a moment while we verify your account...
                </p>

                <div class="margin-20"></div>
              </div>
              <div v-else>
                <div class="swal2-show">
                  <div v-if="success" class="swal2-icon swal2-success swal2-animate-success-icon" style="display: block; margin-top: 0; margin-bottom: 20px">
                    <div class="swal2-success-circular-line-left" style="background: rgb(255, 255, 255);"></div>
                    <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
                    <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
                    <div class="swal2-success-ring"></div>
                    <div class="swal2-success-fix" style="background: rgb(255, 255, 255);"></div>
                    <div class="swal2-success-circular-line-right" style="background: rgb(255, 255, 255);"></div>
                  </div>
                  <div v-else class="swal2-icon swal2-error swal2-animate-error-icon" style="display: block; margin-top: 0; margin-bottom: 20px">
                    <span class="swal2-x-mark swal2-animate-x-mark">
                      <span class="swal2-x-mark-line-left"></span>
                      <span class="swal2-x-mark-line-right"></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div><!-- /.login -->

        </div>
      </div><!-- /.login -->

    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { mapActions } from 'vuex'
  import notify from 'utils/notify'

  export default {
    data () {
      return {
        verifying: true,
        success: true,
        payload: {
          email: null,
          token: null
        }
      }
    },

    mounted () {
      $('body').addClass('pace-top')
    },

    created () {
      const redirectToDashboard = () => {
        this.verifying = false

        setTimeout(() => {
          this.authorize().then(() => {
            this.$router.push({ name: 'dashboard' })
          }).catch(() => {
            this.$router.push({ name: 'auth.login' })
          })
        }, 1500)
      }

      const redirectToLogout = () => {
        this.success = false
        this.verifying = false

        setTimeout(() => {
          notify.error('There was problem verifying your account.')

          this.$router.push({ name: 'auth.logout' })
        }, 2000)
      }

      this.payload.email = this.$route.query.email
      this.payload.token = this.$route.query.token

      if (this.$user.exists && this.$user.email_verified) {
        this.$router.push({ name: 'dashboard' })

        return
      }

      setTimeout(() => {
        this.attemptUserVerification(this.payload).then(redirectToDashboard).catch(redirectToLogout)
      }, 2000)
    },

    methods: {
      ...mapActions('user', ['attemptUserVerification', 'authorize'])
    }
  }
</script>



// WEBPACK FOOTER //
// Verification.vue?66bcbf82